<template>
    <div class="wapper">
        <el-container style="100%">
            <DocumentType @getDocumentTypeId="getDocumentTypeId"></DocumentType>
            <el-main style="background: #fff; margin-left: 10px">
                <div class="table-wrap">
                    <div class="handle-box3">
                        <el-form
                                :inline="true"
                                ref="form"
                                :model="searchForm"
                                class="demo-form-inline handle-search"
                        >
                            <div class="uers-left">
                                <el-form-item label="搜索：">
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.name"
                                            placeholder="姓名"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.code"
                                            placeholder="码值"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.idNumber"
                                            placeholder="编号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.rfid"
                                            placeholder="rfid"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.checkCode"
                                            placeholder="检查"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.author"
                                            placeholder="作者"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-input
                                            style="width: 100px"
                                            v-model="searchForm.remark"
                                            placeholder="备注"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label>
                                    <el-select
                                            style="width: 100px"
                                            v-model="searchForm.projectDoor"
                                            placeholder="选择门禁点"
                                    >
                                        <el-option
                                                v-for="(type, index) in ProjectDoor"
                                                :label="type.name"
                                                :key="index"
                                                :value="type.name"
                                        >
                                            <div @click="getChangeDoorType(type)">
                                                {{ type.name }}
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label>
                                    <el-date-picker
                                            style="width: 150px"
                                            v-model="searchForm.startDate"
                                            type="datetime"
                                            placeholder="开始日期"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item label>
                                    <el-date-picker
                                            style="width: 200px"
                                            v-model="searchForm.endDate"
                                            type="datetime"
                                            placeholder="开始日期"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-button
                                        type="primary"
                                        icon="el-icon-search"
                                        @click="searchSubmit"
                                >搜索
                                </el-button
                                >
                                <el-button
                                        type="primary"
                                        icon="el-icon-export"
                                        @click="exportExcel"
                                >导出
                                </el-button
                                >
                            </div>
                        </el-form>
                    </div>
                    <div class="tabbox">
                        <el-table
                                :data="dataList"
                                height="100%"
                                border
                                class="tabbox"
                                ref="multipleTable"
                                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                                @selection-change="handleSelectionChange"
                        >
                            <el-table-column
                                    type="selection"
                                    width="55"
                                    align="center"
                            ></el-table-column>
                            <el-table-column prop="name" label="名称" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    label="码值"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.code }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="idNumber"
                                    label="编号"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.idNumber }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    label="备注"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.remark }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="checkAvatar"
                                    label="检查人头像"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.checkAvatar }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="checkCode"
                                    label="检查码"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.checkCode }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="door"
                                    label="门禁点"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.door }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="avatar"
                                    label="头像"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <div class="demo-image__preview">
                                        <el-image
                                                style="width: 40px; height: 40px"
                                                :src="scope.row.avatar"
                                                :preview-src-list="[scope.row.avatar]"
                                        ></el-image>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="createDate"
                                    label="创建时间"
                                    align="center"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.createDate }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="删除" width="180" align="center">
                                <template slot-scope="scope">
                                    <el-button
                                            type="text"
                                            class="red"
                                            @click="handleDelete(scope.$index, scope.row)"
                                    >删除
                                    </el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="fb">
                        <el-pagination
                                class="pag"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 15, 20, 50, 100]"
                                :page-size="pagesize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                        ></el-pagination>
                    </div>
                </div>
                <DeleteDialog
                        :delVisible="delVisible"
                        @deleteData="deleteData"
                        @handleCloseVisible="handleCloseVisible"
                ></DeleteDialog>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import EditPapersManage from "../../../components/ticketing/certificate/EditPapersManage";
    import DocumentType from "../../../components/ticketing/certificate/docuType/DocumentType";
    import DeleteDialog from "../../../components/public/DeleteConfim";

    export default {
        data() {
            return {
                total: 0, //总条数
                currentPage: 1, //初始页
                pagesize: 10, // 每页的数据
                //表格高度适配
                tabheight: "",
                searchForm: {
                    name: "",
                    code: "",
                    author: "",
                    remark: "",
                    rfid: "",
                    checkCode: "",
                    idNumber: "",
                    documentTypeId: 0,
                    projectDoor: "",
                    endDate: new Date(
                        new Date(new Date().toLocaleDateString()).getTime() +
                        24 * 60 * 60 * 1000 -
                        1
                    ),
                    startDate: new Date(
                        new Date(new Date().toLocaleDateString()).getTime() -
                        (new Date(new Date().toLocaleDateString()).getTime() -
                            new Date(new Date().getFullYear().toString()))
                    ),
                },
                delVisible: false,
                document_Id: "",
                dataList: [],
                multipleSelection: [],
                projectId: localStorage.getItem("project_Id"),
                projectDoorId: "",
                ProjectDoor: [],
            };
        },
        mounted() {
            // this.tabheight=(this.$refs.getheight.offsetHeight-165)
        },
        created() {
            this.getData();
            this.getProjectDoor();
        },
        methods: {
            handleSizeChange(val) {
                this.pagesize = val;
                this.searchSubmit();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchSubmit();
            },
            img(url) {
                window.open(url);
            },
            exportExcel() {
                var search = {
                    name: this.searchForm.name,
                    code: this.searchForm.code,
                    idNumber: this.searchForm.idNumber,
                    projectId: this.projectId,
                    pageIndex: this.currentPage - 1,
                    author: this.searchForm.author,
                    rfid: this.searchForm.rfid,
                    checkCode: this.searchForm.checkCode,
                    remark: this.searchForm.remark,
                    pageSize: this.total,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    documentTypeId: this.searchForm.documentTypeId,
                    projectDoor: this.searchForm.projectDoor,
                };
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$axios
                    .post("/DocumentCheckCode/Document/Export", search)
                    .then((res) => {
                        loading.close();
                        if (res.data.data) {
                             window.open(res.data.data, '_self');
                            // this.$download(res.data.data, '导出证件.xlsx');
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
                    .catch((a) => {
                        loading.close();
                        this.$message.error("导出失败");
                    });
            },
            searchSubmit() {
                var search = {
                    name: this.searchForm.name,
                    code: this.searchForm.code,
                    idNumber: this.searchForm.idNumber,
                    projectId: this.projectId,
                    pageIndex: this.currentPage - 1,
                    pageSize: this.pagesize,
                    remark: this.searchForm.remark,
                    author: this.searchForm.author,
                    rfid: this.searchForm.rfid,
                    checkCode: this.searchForm.checkCode,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    documentTypeId: this.searchForm.documentTypeId,
                    projectDoor: this.searchForm.projectDoor,
                };
                this.$axios.post("/DocumentCheck/Document/Search", search).then((res) => {
                    if (res.data.hasError == false) {
                        this.dataList = [...res.data.data];
                        this.total = res.data.total;
                    }
                });
            },
            getDocumentTypeId(val) {
                this.searchForm.documentTypeId = val;
                this.getData();
            },
            // 获取数据
            getData() {
                this.currentPage = 1;
                this.searchSubmit();
            },
            handleDelete(index, row) {
                this.document_Id = row.documentCheckId;
                this.delVisible = true;
            },
            deleteData() {
                this.$axios.delete(`/DocumentCheck/${this.document_Id}`).then((res) => {
                    if (res.data.hasError) {
                        this.$message.error(res.data.message);
                    } else {
                        this.$message.success("删除成功！");
                        this.delVisible = false;
                        this.getData();
                    }
                });
            },
            getChangeDoorType(type) {
                this.searchForm.projectDoorId = type.projectDoorId;
            },
            getProjectDoor() {
                console.log(this.projectId);
                this.$axios.get("/ProjectDoor/Project/" + this.projectId).then((res) => {
                    if (res.data.hasError == false) {
                        this.ProjectDoor = [...res.data.data];
                    }
                });
            },
            handleCloseVisible() {
                this.document_Id = "";
                this.delVisible = false;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        },
        components: {
            EditPapersManage,
            DocumentType,
            DeleteDialog,
        },
    };
</script>
<style lang="scss" scope>
    .pag {
        position: absolute;
        bottom: 0;
    }

    .table-wrap {
        height: 100%;
        margin-left: 10px;
    }

    .el-main {
        border-radius: 5px;
        position: relative;
    }

    .tabbox {
        height: calc(100% - 100px);
    }
</style>